import React from "react";
import { websiteUrl } from "../../config/config";
import ProgressBar from "@ramonak/react-progress-bar";
import TippyIcon from "../../revampComponents/Atom/TippyIcon";
import { dashboardColors, theme } from "../../themes/Theme";
import { Icon } from '@iconify/react';
import addIcon from "../../assets/img/add-icon.svg";

const EventLimits = ({ eventDetails, participantCount, isInternational, max_regs_count, purchaseCreditsClickHandler }) => {
	const remainingCredits = eventDetails?.total_credits - eventDetails?.available_credits;

	const shouldShowRegistrationLimits = (eventDetails, isInternational) => {
		if (!eventDetails?.subscription_payment_id && isInternational) return false;
		if (!isInternational && !eventDetails?.eventPlanName) return false;
		return true;
	};

	return (
		<div className="d-flex gap-css">
			{eventDetails && eventDetails?.total_credits !== undefined && eventDetails?.total_credits !== null && eventDetails?.available_credits !== undefined && eventDetails?.available_credits !== null && (
				<TippyIcon content="Event Credits Limit">
					<div className="d-flex credits-container align-items-center" onClick={purchaseCreditsClickHandler}>
						<div className="event-limit-border d-flex justify-content-center align-items-center">
							<Icon
								icon="game-icons:two-coins"
								height="22px"
								width="22px"
								style={{ color: dashboardColors[theme].white }}
							/>
						</div>
						<div className="ml-2 event-limit-container">
							<div className="d-block" style={{ color: dashboardColors[theme].white, fontWeight: 500 }}>
								{remainingCredits}/{eventDetails?.total_credits}
								{/* <img src={addIcon} alt="add-icon" className="ml-2 mb-1" style={{ cursor: "pointer" }} /> */}
							</div>
							<div className="white-text">Buy Credits</div>
							{/* <ProgressBar
								className={`progress-overview-section text-danger`}
								completed={remainingCredits}
								maxCompleted={eventDetails?.total_credits}
								bgColor="#34A853"
								labelColor="white"
								height="5px"
								customLabel={" "}
								labelSize={5}
							/> */}
						</div>
					</div>
				</TippyIcon>
			)}

			{max_regs_count && shouldShowRegistrationLimits(eventDetails, isInternational) ? (
				<>
					<div className="separator"></div>
					<TippyIcon content="Event Registration Limit">
						<div className="d-flex align-items-center">
							<div className="event-limit-border d-flex justify-content-center align-items-center">
								<i
									className="fas fa-users"
									aria-hidden="true"
									style={{ color: "#FFF", fontSize: "16px" }}
								></i>
							</div>
							<div className="ml-2 event-limit-container">
								<div className="d-block ml-1" style={{ color: dashboardColors[theme].white, fontWeight: 500 }}>
									{participantCount}/{eventDetails?.max_regs_count}
								</div>
								<ProgressBar
									className={`progress-overview-section text-danger`}
									completed={participantCount}
									maxCompleted={eventDetails?.max_regs_count}
									bgColor="#34A853"
									labelColor={dashboardColors[theme].white}
									height="5px"
									customLabel={" "}
									// labelAlignment={e.total == null ? "center" : "outside"}
									labelSize={5}
								/>
							</div>
						</div>
					</TippyIcon>
				</>
			) :
				(
					null
				)
			}

			<style>{`
					.event-limit-border {
						width: 36px;
						height: 36px;
						border: 1px solid #FFF;
						border-radius: 100%;
					}	

					.gap-css{
						gap: 20px;
					}	

					.event-limit-container {
						min-width: 70px;
					}
					.separator {
						position: relative;
					}

					.separator::after {
						content: '';
						position: absolute;
						top: 0;
						left: 0;
						width: 1px;
						height: 100%;
						background-color: #c8c8c8;
						transform: scaleX(0.5); 
						transform-origin: 0 0;
					}
					.credits-container{
						padding: 5px 10px;
						border-radius: 4px;
						cursor: pointer;
						background-color: rgba(255, 255, 255, 0.1);
					}
					.white-text{
						color: ${dashboardColors[theme].white};
						font-size: 14px;
						font-weight: 500;
					}
        	    `}</style>
		</div>
	);
};

export default EventLimits;
